import { useState } from 'react'
import { HorizontalBarChart } from '../components'

type Filtro = 'todos' | 'ecuador' | 'peru'

const DATOS = {
  ecuador: {
    total: 9728,
    zonaPrincipal: 'Guayas',
    zonaPrincipalPct: 17.6,
    zonas: [
      ['Guayas', 1710], ['Pichincha', 1266], ['Manabí', 869], ['Guayaquil', 731],
      ['Quito', 642], ['Santo Domingo', 355], ['Loja', 326], ['Azuay', 320],
      ['El Oro', 287], ['Cuenca', 248], ['Manta', 198], ['Tungurahua', 139],
      ['Imbabura', 120], ['Machala', 117], ['Los Ríos', 116], ['Chimborazo', 110],
      ['Ambato', 99], ['Portoviejo', 98], ['Cañar', 60], ['Santa Elena', 52],
      ['Esmeraldas', 52], ['Cotopaxi', 48], ['Daule', 43], ['Quevedo', 41],
      ['Chone', 33], ['Salitre', 30], ['Durán', 29], ['Jipijapa', 28],
      ['Milagro', 24], ['Riobamba', 23], ['Babahoyo', 23], ['Carchi', 17],
      ['Sin Dato', 1052], ['Otros', 134],
    ] as [string, number][],
  },
  peru: {
    total: 2008,
    deptoPrincipal: 'Lima',
    deptoPrincipalPct: 30.0,
    departamentos: [
      ['Lima', 602], ['Arequipa', 230], ['La Libertad', 160], ['Cusco', 132],
      ['San Martín', 130], ['Piura', 82], ['Junín', 82], ['Lambayeque', 78],
      ['Ica', 73], ['Cajamarca', 70], ['Tacna', 69], ['Áncash', 62],
      ['Loreto', 51], ['Callao', 48], ['Ucayali', 38], ['Puno', 23],
      ['Apurímac', 17], ['Madre de Dios', 17], ['Moquegua', 16],
      ['Amazonas', 9], ['Ayacucho', 7], ['Huancavelica', 2], ['Huánuco', 1],
    ] as [string, number][],
  },
}

const fmt = (n: number) => n.toLocaleString('es-PE')
const pct = (a: number, b: number) => b > 0 ? (a / b * 100).toFixed(1) : '0.0'

export function DependientesGlobalPage() {
  const [filtro, setFiltro] = useState<Filtro>('todos')
  const [ecOpen, setEcOpen] = useState(false)
  const [peOpen, setPeOpen] = useState(false)

  const total = DATOS.ecuador.total + DATOS.peru.total
  const pctEc = parseFloat(pct(DATOS.ecuador.total, total))
  const pctPe = parseFloat(pct(DATOS.peru.total, total))

  const zonasOrdenadas = [...DATOS.ecuador.zonas]
    .filter(([k]) => k !== 'Sin Dato')
    .sort(([, a], [, b]) => b - a)

  const chartEC = zonasOrdenadas.slice(0, 20).map(([k, v]) => ({ label: k, value: v, color: '#2fbc80' }))
  const chartPE = DATOS.peru.departamentos.map(([k, v]) => ({ label: k, value: v, color: '#57a6d8' }))

  const btnBase = 'flex-1 py-2 rounded-lg text-sm font-semibold transition-all duration-200 text-center'
  const btnActive = `${btnBase} bg-white text-gray-900 shadow-sm`
  const btnInactive = `${btnBase} text-gray-500 hover:text-gray-700`

  return (
    <div className="bg-gray-100 p-4 lg:p-6 min-h-screen">
      <div className="max-w-7xl mx-auto">

        {/* Header */}
        <div className="bg-white rounded-2xl shadow-sm p-5 lg:p-7 mb-6">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-5">
              <img src="/logo-tonal-negro.png" alt="Tonal" className="h-9 w-auto" />
              <div>
                <h1 className="text-xl lg:text-2xl font-bold text-gray-900">Dependientes Global</h1>
                <p className="text-sm text-gray-500 mt-0.5">Base de farmacéuticos dependientes · Ecuador &amp; Perú</p>
              </div>
            </div>
            <div className="flex bg-gray-100 rounded-xl p-1 w-full">
              <button onClick={() => setFiltro('todos')} className={filtro === 'todos' ? btnActive : btnInactive}>
                🌎 Global
              </button>
              <button onClick={() => setFiltro('ecuador')} className={filtro === 'ecuador' ? btnActive : btnInactive}>
                🇪🇨 Ecuador
              </button>
              <button onClick={() => setFiltro('peru')} className={filtro === 'peru' ? btnActive : btnInactive}>
                🇵🇪 Perú
              </button>
            </div>
          </div>
        </div>

        {/* ═══ GLOBAL ═══ */}
        {filtro === 'todos' && (
          <>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
              <div className="bg-white rounded-xl shadow-sm p-5 text-center">
                <p className="text-3xl lg:text-4xl font-bold text-gray-900">{fmt(total)}</p>
                <p className="text-xs text-gray-500 mt-1.5 font-medium uppercase tracking-wide">Total Dependientes</p>
              </div>
              <div className="bg-white rounded-xl shadow-sm p-5 text-center">
                <p className="text-3xl lg:text-4xl font-bold text-[#2fbc80]">{fmt(DATOS.ecuador.total)}</p>
                <p className="text-xs text-gray-500 mt-1.5 font-medium uppercase tracking-wide">🇪🇨 Ecuador</p>
              </div>
              <div className="bg-white rounded-xl shadow-sm p-5 text-center">
                <p className="text-3xl lg:text-4xl font-bold text-[#57a6d8]">{fmt(DATOS.peru.total)}</p>
                <p className="text-xs text-gray-500 mt-1.5 font-medium uppercase tracking-wide">🇵🇪 Perú</p>
              </div>
              <div className="bg-white rounded-xl shadow-sm p-5 text-center">
                <p className="text-3xl lg:text-4xl font-bold text-[#8d82bc]">{pctEc}%</p>
                <p className="text-xs text-gray-500 mt-1.5 font-medium uppercase tracking-wide">Ecuador / Total</p>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 mb-6">
              {/* Barras comparativas */}
              <div className="bg-white rounded-xl shadow-sm p-6">
                <h3 className="font-semibold text-gray-900 mb-5">Distribución por País</h3>
                <div className="space-y-5">
                  <div>
                    <div className="flex justify-between text-sm mb-1.5">
                      <span className="text-gray-700 font-medium">🇪🇨 Ecuador</span>
                      <span className="font-bold text-gray-900">{fmt(DATOS.ecuador.total)} <span className="text-xs font-normal text-gray-400">{pctEc}%</span></span>
                    </div>
                    <div className="h-3 bg-gray-100 rounded-full overflow-hidden">
                      <div className="h-3 rounded-full bg-[#2fbc80]" style={{ width: `${pctEc}%` }} />
                    </div>
                  </div>
                  <div>
                    <div className="flex justify-between text-sm mb-1.5">
                      <span className="text-gray-700 font-medium">🇵🇪 Perú</span>
                      <span className="font-bold text-gray-900">{fmt(DATOS.peru.total)} <span className="text-xs font-normal text-gray-400">{pctPe}%</span></span>
                    </div>
                    <div className="h-3 bg-gray-100 rounded-full overflow-hidden">
                      <div className="h-3 rounded-full bg-[#57a6d8]" style={{ width: `${pctPe}%` }} />
                    </div>
                  </div>
                </div>
                <p className="text-xs text-gray-400 mt-6">Selecciona un país en el filtro para ver el desglose geográfico detallado.</p>
              </div>
              {/* Resumen */}
              <div className="bg-white rounded-xl shadow-sm p-6">
                <h3 className="font-semibold text-gray-900 mb-4">Resumen por País</h3>
                <div className="space-y-4">
                  <div className="flex items-center justify-between p-4 bg-green-50 rounded-xl">
                    <div className="flex items-center gap-3">
                      <span className="text-2xl">🇪🇨</span>
                      <div>
                        <p className="font-semibold text-gray-900">Ecuador</p>
                        <p className="text-xs text-gray-500">Zona principal: {DATOS.ecuador.zonaPrincipal}</p>
                      </div>
                    </div>
                    <div className="text-right">
                      <p className="text-xl font-bold text-[#2fbc80]">{fmt(DATOS.ecuador.total)}</p>
                      <p className="text-xs text-gray-500">{pctEc}% del total</p>
                    </div>
                  </div>
                  <div className="flex items-center justify-between p-4 bg-blue-50 rounded-xl">
                    <div className="flex items-center gap-3">
                      <span className="text-2xl">🇵🇪</span>
                      <div>
                        <p className="font-semibold text-gray-900">Perú</p>
                        <p className="text-xs text-gray-500">Dpto. principal: {DATOS.peru.deptoPrincipal}</p>
                      </div>
                    </div>
                    <div className="text-right">
                      <p className="text-xl font-bold text-[#57a6d8]">{fmt(DATOS.peru.total)}</p>
                      <p className="text-xs text-gray-500">{pctPe}% del total</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {/* ═══ ECUADOR ═══ */}
        {filtro === 'ecuador' && (
          <>
            <div className="flex items-center gap-3 mb-4">
              <span className="text-2xl">🇪🇨</span>
              <h2 className="text-lg font-bold text-gray-800">Ecuador</h2>
              <span className="text-xs font-semibold bg-[#2fbc80]/10 text-[#2fbc80] px-2.5 py-0.5 rounded-full">{fmt(DATOS.ecuador.total)} dependientes</span>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mb-5">
              <div className="bg-white rounded-xl shadow-sm p-4 text-center">
                <p className="text-2xl font-bold text-gray-900">{fmt(DATOS.ecuador.total)}</p>
                <p className="text-xs text-gray-500 mt-1">Total Registros</p>
              </div>
              <div className="bg-white rounded-xl shadow-sm p-4 text-center">
                <p className="text-2xl font-bold text-[#57a6d8]">{DATOS.ecuador.zonaPrincipal}</p>
                <p className="text-xs text-gray-500 mt-1">Zona Principal</p>
              </div>
              <div className="bg-white rounded-xl shadow-sm p-4 text-center">
                <p className="text-2xl font-bold text-[#8d82bc]">{DATOS.ecuador.zonaPrincipalPct}%</p>
                <p className="text-xs text-gray-500 mt-1">Zona Principal %</p>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-sm p-5 mb-5">
              <h3 className="font-semibold text-gray-900 mb-4">Top Zonas / Ciudades — Ecuador <span className="text-xs font-normal text-gray-400">(excluyendo Sin Dato)</span></h3>
              <HorizontalBarChart data={chartEC} />
            </div>

            <div className="bg-white rounded-xl shadow-sm p-5 mb-6">
              <button onClick={() => setEcOpen(o => !o)} className="w-full text-left group">
                <div className="flex items-center justify-between">
                  <span className="font-semibold text-gray-900 text-sm group-hover:text-[#2fbc80] transition-colors">Desglose completo por Zona</span>
                  <svg className={`w-4 h-4 text-gray-400 transform transition-transform duration-200 ${ecOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </button>
              {ecOpen && (
                <div className="mt-4 overflow-x-auto">
                  <table className="min-w-full text-sm">
                    <thead className="bg-gray-50 border-b border-gray-200">
                      <tr>
                        <th className="px-4 py-2.5 text-left text-xs font-semibold text-gray-600 uppercase">#</th>
                        <th className="px-4 py-2.5 text-left text-xs font-semibold text-gray-600 uppercase">Zona / Ciudad</th>
                        <th className="px-4 py-2.5 text-right text-xs font-semibold text-gray-600 uppercase">Registros</th>
                        <th className="px-4 py-2.5 text-right text-xs font-semibold text-gray-600 uppercase">%</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-50">
                      {[...DATOS.ecuador.zonas].sort(([, a], [, b]) => b - a).map(([zona, n], i) => (
                        <tr key={zona} className="hover:bg-gray-50">
                          <td className="px-4 py-2 text-xs text-gray-400">{i + 1}</td>
                          <td className="px-4 py-2 text-sm text-gray-800">{zona}</td>
                          <td className="px-4 py-2 text-sm text-right font-semibold text-gray-900">{fmt(n)}</td>
                          <td className="px-4 py-2 text-xs text-right text-gray-500">{pct(n, DATOS.ecuador.total)}%</td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr className="border-t-2 border-gray-200 bg-gray-50">
                        <td className="px-4 py-2.5 text-xs font-bold text-gray-700" colSpan={2}>TOTAL</td>
                        <td className="px-4 py-2.5 text-right text-xs font-bold text-gray-900">{fmt(DATOS.ecuador.total)}</td>
                        <td className="px-4 py-2.5 text-right text-xs font-bold text-[#2fbc80]">100%</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              )}
            </div>
          </>
        )}

        {/* ═══ PERÚ ═══ */}
        {filtro === 'peru' && (
          <>
            <div className="flex items-center gap-3 mb-4">
              <span className="text-2xl">🇵🇪</span>
              <h2 className="text-lg font-bold text-gray-800">Perú</h2>
              <span className="text-xs font-semibold bg-[#57a6d8]/10 text-[#57a6d8] px-2.5 py-0.5 rounded-full">{fmt(DATOS.peru.total)} dependientes</span>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-5">
              <div className="bg-white rounded-xl shadow-sm p-4 text-center">
                <p className="text-2xl font-bold text-gray-900">{fmt(DATOS.peru.total)}</p>
                <p className="text-xs text-gray-500 mt-1">Total Registros</p>
              </div>
              <div className="bg-white rounded-xl shadow-sm p-4 text-center">
                <p className="text-2xl font-bold text-[#8d82bc]">{DATOS.peru.departamentos.length}</p>
                <p className="text-xs text-gray-500 mt-1">Departamentos</p>
              </div>
              <div className="bg-white rounded-xl shadow-sm p-4 text-center">
                <p className="text-2xl font-bold text-[#57a6d8]">{DATOS.peru.deptoPrincipal}</p>
                <p className="text-xs text-gray-500 mt-1">Dpto. Principal</p>
              </div>
              <div className="bg-white rounded-xl shadow-sm p-4 text-center">
                <p className="text-2xl font-bold text-[#8d82bc]">{DATOS.peru.deptoPrincipalPct}%</p>
                <p className="text-xs text-gray-500 mt-1">Dpto. Principal %</p>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-sm p-5 mb-5">
              <h3 className="font-semibold text-gray-900 mb-4">Por Departamento</h3>
              <HorizontalBarChart data={chartPE} />
            </div>

            <div className="bg-white rounded-xl shadow-sm p-5 mb-6">
              <button onClick={() => setPeOpen(o => !o)} className="w-full text-left group">
                <div className="flex items-center justify-between">
                  <span className="font-semibold text-gray-900 text-sm group-hover:text-[#57a6d8] transition-colors">Desglose completo por Departamento</span>
                  <svg className={`w-4 h-4 text-gray-400 transform transition-transform duration-200 ${peOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </button>
              {peOpen && (
                <div className="mt-4 overflow-x-auto">
                  <table className="min-w-full text-sm">
                    <thead className="bg-gray-50 border-b border-gray-200">
                      <tr>
                        <th className="px-4 py-2.5 text-left text-xs font-semibold text-gray-600 uppercase">#</th>
                        <th className="px-4 py-2.5 text-left text-xs font-semibold text-gray-600 uppercase">Departamento</th>
                        <th className="px-4 py-2.5 text-right text-xs font-semibold text-gray-600 uppercase">Registros</th>
                        <th className="px-4 py-2.5 text-right text-xs font-semibold text-gray-600 uppercase">%</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-50">
                      {DATOS.peru.departamentos.map(([depto, n], i) => (
                        <tr key={depto} className="hover:bg-gray-50">
                          <td className="px-4 py-2 text-xs text-gray-400">{i + 1}</td>
                          <td className="px-4 py-2 text-sm text-gray-800">{depto}</td>
                          <td className="px-4 py-2 text-sm text-right font-semibold text-gray-900">{fmt(n)}</td>
                          <td className="px-4 py-2 text-xs text-right text-gray-500">{pct(n, DATOS.peru.total)}%</td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr className="border-t-2 border-gray-200 bg-gray-50">
                        <td className="px-4 py-2.5 text-xs font-bold text-gray-700" colSpan={2}>TOTAL</td>
                        <td className="px-4 py-2.5 text-right text-xs font-bold text-gray-900">{fmt(DATOS.peru.total)}</td>
                        <td className="px-4 py-2.5 text-right text-xs font-bold text-[#57a6d8]">100%</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              )}
            </div>
          </>
        )}

        {/* Footer */}
        <div className="bg-white rounded-xl shadow-sm p-4 text-center text-gray-400 text-xs">
          &copy; 2026 Tonal Strategies · Base Dependientes Global · Ecuador &amp; Perú
        </div>

      </div>
    </div>
  )
}
